import { ContentChild, Directive, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

export type MyLeadLayoutItemState = 'default' | 'expanded' | 'collapsed' | 'default-mobile';

@Directive({
  selector: '[layout-item-header]'
})
export class MyLeadLayoutItemHeader {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: '[layout-item-title]'
})
export class MyLeadLayoutItemTitle {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: '[layout-item-content]'
})
export class MyLeadLayoutItemContent {
  constructor(public templateRef: TemplateRef<Element>) {}
}

@Directive({
  selector: 'layout-item'
})
export class MyLeadLayoutItem {
  @Input() title = '';
  @Input() icon = '';
  @Input() showButton = false;
  @Input() fluid = false;
  @Input() state: MyLeadLayoutItemState = 'default';

  @Output() buttonClick = new EventEmitter<void>();

  @ContentChild(MyLeadLayoutItemTitle) customTitle: MyLeadLayoutItemTitle;
  @ContentChild(MyLeadLayoutItemContent) content: MyLeadLayoutItemContent;
  @ContentChild(MyLeadLayoutItemHeader) customHeader: MyLeadLayoutItemHeader;

  constructor() {}

  public toggle = (isToggled: boolean, isTablet: boolean) => {
    if (isTablet) return this.setState(isToggled ? 'expanded' : 'collapsed');

    const isExpandedOrCollapsed = this.isExpanded() || this.isCollapsed();

    this.setState(isExpandedOrCollapsed ? 'default' : isToggled ? 'expanded' : 'collapsed');
  };

  public isDefault = () => {
    return this.state === 'default';
  };

  public isExpanded = () => {
    return this.state === 'expanded';
  };

  public isCollapsed = () => {
    return this.state === 'collapsed';
  };

  public setState = (state: MyLeadLayoutItemState) => {
    this.state = state;
  };
}

export const MyLeadLayoutElements = [MyLeadLayoutItem, MyLeadLayoutItemContent, MyLeadLayoutItemHeader, MyLeadLayoutItemTitle];
